<template>
  <div>
    <b-modal
      title="تایید دستی"
      id="manual-desition"
      @ok.prevent="saveManualDesition"
      ok-title="تایید"
      cancel-title="انصراف"
    >
      <b-form-group label="وضعیت انتخابی:">
        <b-form-select
          v-model="manualDesition.result"
          :options="[
            { text: 'OK', value: 'OK' },
            { text: 'FAILED', value: 'FAILED' },
            { text: 'WAIT', value: 'FAILED' },
          ]"
        ></b-form-select>
      </b-form-group>
      <b-form-group label="روش انتقال:">
        <b-form-select
          v-model="manualDesition.method"
          :options="[
            { text: 'داخلی', value: 'INTERNAL' },
            { text: 'پایا', value: 'PAYA' },
            { text: 'ساتنا', value: 'SATNA' },
          ]"
        ></b-form-select>
      </b-form-group>
      <b-form-group label="انتقال از طریق:">
        <b-form-select
          v-model="manualDesition.provider"
          :options="banksProviders"
        ></b-form-select>
      </b-form-group>
    </b-modal>
    <b-card title="جزییات تسهیم">
      <b-card-body class="p-0">
        <b-tabs nav-wrapper-class="w-100">
          <b-tab title="اطلاعات تراکنش" active class="p-3">
            <div class="row">
              <b-col>
                <b-form-group label="نام درخواست دهنده">
                  <div class="form-control">
                    {{ gateway.user ? gateway.user.name : "" }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="تاریخ ثبت">
                  <div class="form-control">
                    {{ persianDate(transfer.createdAt) }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="تاریخ تایید">
                  <div class="form-control">
                    {{ persianDate(transfer.submittedAt) }}
                  </div>
                </b-form-group>
              </b-col>
            </div>
            <div class="row">
              <b-col>
                <b-form-group label="وبسایت">
                  <div class="form-control">
                    {{ gateway.website_name }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col> </b-col>
              <b-col> </b-col>
            </div>
            <div class="row">
              <b-col>
                <b-form-group label="نام صاحب حساب مقصد">
                  <div class="form-control">
                    {{
                      transfer.destinationFirstName +
                      " " +
                      transfer.destinationLastName
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="شماره شبا">
                  <div class="form-control">
                    {{ transfer.destinationIban }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="بانک مقصد">
                  <div class="form-control">
                    {{ transfer.destinationBank }}
                  </div>
                </b-form-group>
              </b-col>
            </div>
            <div class="row">
              <b-col>
                <b-form-group label="مبلغ">
                  <div class="form-control">
                    {{ numbrize(transfer.amount) }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="وضعیت تسویه">
                  <div class="form-control">
                    {{ translateStatus(transfer.status) }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="مرحله">
                  <div class="form-control">
                    {{ translateState(transfer.state) }}
                  </div>
                </b-form-group>
              </b-col>
            </div>
            <div class="row">
              <b-col>
                <b-form-group label="کد رهگیری بانک">
                  <div class="form-control">
                    {{ transfer.bankTrackingNumber }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="بانک مبدا">
                  <div class="form-control">
                    {{
                      successTransferProcess
                        ? successTransferProcess.sourceAccount.nickname
                        : ""
                    }}
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="شماره شبا مبدا">
                  <div class="form-control">
                    {{
                      successTransferProcess
                        ? successTransferProcess.sourceAccount.iban
                        : ""
                    }}
                  </div>
                </b-form-group>
              </b-col>
            </div>
            <div class="row">
              <b-button
                v-b-modal.manual-desition
                v-if="transfer.status == 'PRE_FAILED'"
                variant="danger"
                >تایید دستی</b-button
              >
            </div>
          </b-tab>
          <b-tab title="تلاش های انجام شده برای انتقال">
            <b-table
              :items="transfer.transferProcesses"
              :fields="transferProcessesFields"
            ></b-table>
          </b-tab>
          <b-tab title="تصمیم گیری ها">
            <b-table
              :items="transfer.transferDecisions"
              :fields="transferDecisionsFields"
            ></b-table>
          </b-tab>

          <b-tab title="تصمیم گیری های استراتژی">
            <b-table
              :items="StrategyTransfer.decisions"
              :fields="stTransferDecisionFields"
            ></b-table>
          </b-tab>
          <b-tab title="تصمیم گیری های دستی">
            <b-table
              :items="StrategyTransfer.manualDecisions"
              :fields="stTransferManualDecisionFields"
            ></b-table>
          </b-tab>
        </b-tabs>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import moment from "jalali-moment";
import httpHelper from "../../helpers/httpHelper";
import router from "../../router";
export default {
  name: "TransferDetails",
  data() {
    return {
      transfer: {},
      gateway: {},
      StrategyTransfer: {},
      banksProviders: [],
      manualDesition: {
        transferId: "",
        result: "OK",
        method: "INTERNAL",
        waitSeconds: 30,
      },
      successTransferProcess: {},
      transferProcessesFields: [
        {
          key: "status",
          label: "وضعیت",
        },
        {
          key: "transferType",
          label: "نوع پرداخت",
        },
        {
          key: "bankTrackingNumber",
          label: "کد رهگیری پرداخت",
        },
        {
          key: "sourceAccount.iban",
          label: "شبای مبدا",
        },
        {
          key: "bankWage",
          label: "کارمزد بانک",
        },
        {
          key: "providerWage",
          label: "کارمزد پروایدر",
        },
        {
          key: "createdAt",
          label: "تاریخ ایجاد",
          formatter: (value, key, item) => {
            return this.persianDate(value);
          },
        },
        {
          key: "updatedAt",
          label: "تاریخ بروزرسانی",
          formatter: (value, key, item) => {
            return this.persianDate(value);
          },
        },
      ],
      transferDecisionsFields: [
        {
          key: "status",
          label: "وضعیت",
        },
        {
          key: "transferType",
          label: "نوع انتقال",
        },
        {
          key: "tryCount",
          label: "تعداد تلاش",
        },
        {
          key: "sourceAccount.nickname",
          label: "بانک مبدا",
        },
        {
          key: "sourceAccount.iban",
          label: "شماره شبا مبدا",
        },
        {
          key: "failedCode",
          label: "کد خطا انتقال",
        },
        {
          key: "createdAt",
          label: "تاریخ ایجاد",
          formatter: (value, key, item) => {
            return this.persianDate(value);
          },
        },
      ],
      stTransferDecisionFields: [
        {
          key: "result",
          label: "وضعیت",
        },
        {
          key: "transferType",
          label: "نوع انتقال",
        },
        {
          key: "tryCount",
          label: "تعداد تلاش",
        },
        {
          key: "provider",
          label: "بانک مبدا",
        },
        {
          key: "callbackStatus",
          label: "وضعیت پاسخ بانک",
        },
        {
          key: "callbackReasonFailed",
          label: "پاسخ بانک در صورت خطا",
        },
        {
          key: "createdAt",
          label: "تاریخ ایجاد",
          formatter: (value, key, item) => {
            return this.persianDate(value);
          },
        },
      ],
      stTransferManualDecisionFields: [
        {
          key: "result",
          label: "وضعیت",
        },
        {
          key: "method",
          label: "نوع انتقال",
        },
        {
          key: "provider",
          label: "بانک مبدا",
        },
        {
          key: "isUsed",
          label: "استفاده شده",
        },
        {
          key: "waitSeconds",
          label: "مدت زمان انتظار",
        },
        {
          key: "createdAt",
          label: "تاریخ ایجاد",
          formatter: (value, key, item) => {
            return this.persianDate(value);
          },
        },
      ],
    };
  },
  methods: {
    saveManualDesition() {
      httpHelper
        .postData(
          "~transfer-strategy/transfers/manual-decision",
          this.manualDesition
        )
        .then((res) => {
          this.$bvModal.hide("manual-desition");
        });
    },
    numbrize(number) {
      if (number) return Number(number).toLocaleString();
      return 0;
    },
    persianDate(date) {
      if (date) return moment(date).format("jYYYY/jMM/jDD HH:mm:ss");
      return "-----";
    },
    translateStatus(status) {
      switch (status) {
        case "PENDING":
          return "ترنسفر در حال انجام";
        case "SUCCESS":
          return "تراکنش موفق و دریافت کد رهگیری از بانک";
        case "PRE_FAILED":
          return "نیاز به بررسی دوباره";
        case "FAILED":
          return "خطا در انجام عملیات";
        default:
          return "ناشناخته";
      }
    },
    translateState(state) {
      switch (state) {
        case "STORE":
          return "دخیر ترنسفر بعد از احراز هویت سمت شپا";
        case "SEND_STRATEGY":
          return "ارسال اطلاعات ترنسفر به سرویس استراتژی ";
        case "RECEIVE_STRATEGY":
          return "دریافت اکشن و پروایدر از سرویس استراتژی";
        case "SEND_TO_PROVIDER":
          return "ارسال درخواست ترنسفر به پروایدر مربوطه";
        case "COMPLETE":
          return "تکمیل فرآیند و دریافت نتیجه نهایی از پروایدر";
        default:
          return "ناشناخته";
      }
    },
    getPbankProviders() {
      httpHelper.getData("~transfer-strategy/banks/providers").then((res) => {
        this.banksProviders = res.data.map((res) => {
          return {
            text: res.label,
            value: res.nickname,
            data: res,
          };
        });
        this.loadData();
      });
    },
  },
  mounted() {
    this.getPbankProviders();
    httpHelper
      .getData(`~transferapi/admin/transfer/${this.$route.params.id}`)
      .then((res) => {
        this.transfer = res;
        this.successTransferProcess = this.transfer.transferProcesses.find(
          (o) => {
            return o.status == "SUCCESS";
          }
        );
        httpHelper
          .getData(`paymentgateways?id=${this.transfer.gatewayId}`)
          .then((gres) => {
            this.gateway = gres.result;
          });
        httpHelper
          .getData("~transfer-strategy/transfers/" + this.transfer.orderId)
          .then((strategyRes) => {
            this.StrategyTransfer = strategyRes.data;
            this.manualDesition.transferId = this.StrategyTransfer.id;
          });
      });
  },
};
</script>